/**
 * @desc 站点风采模块
 */
const webSiteWonderfulList = r => require.ensure([], () => r(require('../views/webSiteWonderful/WebSiteWonderfulList.vue')), 'webSiteWonderfulList');

export default [
  //站点风采列表
  {
    name: 'webSiteWonderfulList',
    path: '/webSiteWonderfulList',
    component: webSiteWonderfulList,
    meta: { title: '首页风采列表' },
  },
]